import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  gridRow: {
    "&:not(:last-child)": {
      marginBottom: 30,
    },
  },
  editButton: {
    marginRight: 15,
  },
  assigneeName: {
    marginBottom: 10,
  },
  email: {
    color: "#333",
    textDecoration: "none",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
